import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  accessToken: null,
  user: null,
  isAuthenticated: false,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setCredentials: (state, action) => {
      const { user, accessToken } = action.payload || {};
      if (accessToken !== undefined) {
        state.accessToken = accessToken;
        state.isAuthenticated = Boolean(accessToken);
      }
      if (user !== undefined) {
        state.user = user;
      }
    },
    setAccessToken: (state, action) => {
      state.accessToken = action.payload || null;
      state.isAuthenticated = Boolean(action.payload);
    },
    setUser: (state, action) => {
      state.user = action.payload || null;
    },
    clearCredentials: (state) => {
      state.accessToken = null;
      state.user = null;
      state.isAuthenticated = false;
    },
  },
});

export const {
  setCredentials,
  setAccessToken,
  setUser,
  clearCredentials,
} = authSlice.actions;

export const selectCurrentUser = (state) => state.auth?.user;
export const selectAccessToken = (state) => state.auth?.accessToken;
export const selectIsAuthenticated = (state) => Boolean(state.auth?.accessToken);

export default authSlice.reducer;
